
export default 
    [
		{ id:1 , question:'FOD inspection of ramp was conducted, prior to aircraft arrival' },
		{ id:2 , question:'Aircraft stairs at pilots door were set into position correctly' },
		{ id:3 , question:'4 inches of spacing existed between the chocks and the front, and back, of tires on rear landing gear' },
		{ id:4 , question:'LCD- 4 inches with no metal to metal contact' },
		{ id:5 , question:'Cone placement was correct around perimeter of Aircraft' },
		{ id:6 , question:'Belt & K Loaders were set up at the 8ft stop points. (rails raised, belt elevated, etc, . . )' },
		{ id:7 , question:'Belt and K-Loader drivers were ground guided in from their the 8 foot stop points' },
		{ id:8 , question:'Employees did not walk under the midline of the plane in between the aircraft tires' },
		{ id:9 , question:'K-Loader Platform was raised completely, Prior to employees ascending or descending the stairs' },
		{ id:10 , question: 'Employees maintained three points of contact while ascending and / or descending stairs' },
		{ id:11 , question: 'Belt loader rails were extended to 16inches of plane' },
		{ id:12 , question: 'Belt loader was placed in park & chocked before employee ascended the belt' },
		{ id:13 , question: 'Once door is opened fully, belt is pulled off and pulled back up to proceed with un' },
		{ id:14 , question: 'I ensured that all employees had their seat belts on before moving their equipment' },
		{ id:15 , question: '50ft and 8ft test stops were completed by the tug operator under the guidance of a ground guide' },
		{ id:16 , question: 'Supervisor confirmed the correct fuel weight before beginning the unload?' },
		{ id:17 , question: 'Confirm ULD serviceability for every one unloaded' },
		{ id:18 , question: 'Physically confirm all seals are intact on container doors' },
		{ id:19 , question: 'All ULD empties are opened and inspected for debris' },
		{ id:20 , question: 'All locks are put-up after unload' },
		{ id:21 , question: 'All locks are put-up after unload' },
		{ id:22 , question: 'All locks are put-up after unload' },
		{ id:23 , question: 'All locks are put-up after unload' },
		{ id:24 , question: 'All locks are put-up after unload' },
		{ id:25 , question: 'All locks are put-up after unload' },
		{ id:26 , question: 'All locks are put-up after unload' },
		{ id:27 , question: 'All locks are put-up after unload' },
    ]
    
